"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = require("../form-definition");
var immutable_1 = require("immutable");
var actionTypes = form_definition_1.formRuleTypes.actionTypes;
/**
 * this function applies a form action to the state, modifying the state based on the action's
 * type, value and the elementId of the associated element
 * @param {FormState} state initial FormState before the ation is applied
 * @param {FormAction} action the action to be applied ot the FormState
 */
function actionReducer(state, action) {
    var elementId = action.elementId, actionType = action.type, actionValue = action.value;
    if (actionType === actionTypes.ignore)
        return state;
    var info = form_definition_1.getElementInfo(state, elementId);
    var element = info && info.element;
    if (!element) {
        return state;
    }
    // modify the state based on the actionType and element information
    switch (actionType) {
        case actionTypes.makeRequired: {
            if (!form_definition_1.elementStoresData(element.type)) {
                // cannot make elements required that do not store user input
                return state;
            }
            if (element.hidden) {
                return state.setIn(info.path.concat(['hidden']), false).setIn(info.path.concat(['isRequired']), true);
            }
            return state.setIn(info.path.concat(['isRequired']), true);
        }
        case actionTypes.makeNotRequired: {
            if (!form_definition_1.elementStoresData(element.type)) {
                // cannot make elements required that do not store user input
                return state;
            }
            return state.setIn(info.path.concat(['isRequired']), false);
        }
        case actionTypes.hide: {
            return state.setIn(info.path.concat(['hidden']), true);
        }
        case actionTypes.show: {
            return state.setIn(info.path.concat(['hidden']), false);
        }
        case actionTypes.setDefault: {
            var modifiedValue = getActionValue(element, actionValue);
            return state.setIn(['initialValues', element.id], modifiedValue);
        }
        case actionTypes.setValue: {
            var modifiedValue = getActionValue(element, actionValue);
            return state.setIn(info.path.concat(['readOnly']), true)
                .setIn(['value', element.id], modifiedValue);
        }
        case actionTypes.changeCountry: {
            switch (element.type) {
                case form_definition_1.elementTypes.postalCode:
                    return state.setIn(info.path.concat(['country']), action.value);
                default:
                    return state;
            }
        }
        case actionTypes.disable: {
            return state.setIn(info.path.concat(['disabled']), true);
        }
        case actionTypes.enable: {
            return state.setIn(info.path.concat(['disabled']), false);
        }
        case actionTypes.lock: {
            return state.setIn(info.path.concat(['readOnly']), true);
        }
        case actionTypes.unlock: {
            return state.setIn(info.path.concat(['readOnly']), false);
        }
        default: return state;
    }
}
exports.actionReducer = actionReducer;
function getActionValue(element, value) {
    if (!element)
        return value;
    switch (element.type) {
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
            return immutable_1.List(value);
        default:
            return value;
    }
}
//# sourceMappingURL=action.reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/rules-engine/action.reducer.js
// module id = 1160
// module chunks = 0